import { render } from "./icons-file-info-alt.svg?vue&type=template&id=6aaef5db?inline"
const script = {}
script.render = render

export default script